import clsx from 'clsx';
import { LuChevronDown, LuChevronUp } from 'react-icons/lu';
import { PhonicsLesson, PhonicsLessonGroup } from '@/api/types';
import { ManagePanel } from './ManagePanel';

interface WeekGroupItemProps {
  weekGroup: PhonicsLessonGroup;
  subHeading?: string;
  onOpen: () => void;
  isOpen?: boolean;
  podMode?: boolean;
  onRenderLesson: (lesson: PhonicsLesson, index: number) => React.ReactNode;
}

export const WeekGroupItem = ({
  weekGroup,
  subHeading,
  onOpen,
  isOpen = false,
  podMode = true,
  onRenderLesson,
}: WeekGroupItemProps) => (
  <ManagePanel spacing="sm" yOrientation>
    <button onClick={onOpen}>
      <h2 className="flex gap-2 font-bold text-pt-primary dark:text-pt-lightening-yellow text-left">
        {isOpen ? (
          <LuChevronUp className="w-6 h-6" />
        ) : (
          <LuChevronDown className="w-6 h-6" />
        )}
        {` `}
        {weekGroup.name}
      </h2>

      {subHeading && (
        <h3 className="text-lg text-pt-primary dark:text-pt-lightening-yellow text-left">
          {subHeading}
        </h3>
      )}
    </button>

    {isOpen && (
      <div className={clsx('flex gap-3', podMode ? 'flex-wrap' : 'flex-col')}>
        {weekGroup.lessons?.map((lesson, index) =>
          onRenderLesson(lesson, index),
        )}
      </div>
    )}
  </ManagePanel>
);

interface ManageYearWeekLessonAccordionProps {
  lessonGroups: Array<PhonicsLessonGroup>;
  openYearGroup: PhonicsLessonGroup | undefined;
  setOpenYearGroup: (group: PhonicsLessonGroup | undefined) => void;
  openWeekGroup: PhonicsLessonGroup | undefined;
  setOpenWeekGroup: (group: PhonicsLessonGroup | undefined) => void;
  onRenderLesson: (lesson: PhonicsLesson, index: number) => React.ReactNode;
  onGetWeekSubHeading?: (weekGroup: PhonicsLessonGroup) => string | undefined;
  podMode?: boolean;
}

export const ManageYearWeekLessonAccordion = ({
  lessonGroups,
  openYearGroup,
  setOpenYearGroup,
  openWeekGroup,
  setOpenWeekGroup,
  onRenderLesson,
  onGetWeekSubHeading,
  podMode = true,
}: ManageYearWeekLessonAccordionProps) => (
  <div className="flex flex-col gap-3">
    {lessonGroups.map((yearGroup) => (
      <ManagePanel
        key={yearGroup.id}
        spacing="sm"
        bgColorScheme="white"
        yOrientation
        title={yearGroup.name}
        titleWithoutUnderline
        titleAccessory={
          openYearGroup === yearGroup ? (
            <LuChevronUp className="w-6 h-6" />
          ) : (
            <LuChevronDown className="w-6 h-6" />
          )
        }
        onClickTitle={() =>
          setOpenYearGroup(openYearGroup === yearGroup ? undefined : yearGroup)
        }
        titleTooltipText="Click to expand/collapse the year"
        titleTooltipPosition="right"
      >
        {openYearGroup === yearGroup &&
          yearGroup.children &&
          yearGroup.children.map((weekGroup) => (
            <WeekGroupItem
              key={weekGroup.id}
              weekGroup={weekGroup}
              subHeading={onGetWeekSubHeading?.(weekGroup)}
              onOpen={() =>
                setOpenWeekGroup(
                  openWeekGroup === weekGroup ? undefined : weekGroup,
                )
              }
              isOpen={openWeekGroup === weekGroup}
              podMode={podMode}
              onRenderLesson={onRenderLesson}
            />
          ))}
      </ManagePanel>
    ))}
  </div>
);
